module.exports = __webpack_public_path__ + "img/double_diamond.460cfb24.png";